import * as React from 'react';

export const ArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8.338" height="16.677" viewBox="0 0 8.338 16.677"><path d="M2.514,8.336,8.032,2.031a1.31,1.31,0,0,0,0-1.683.957.957,0,0,0-1.476,0L.3,7.492a1.316,1.316,0,0,0-.03,1.643l6.279,7.194a.958.958,0,0,0,1.476,0,1.31,1.31,0,0,0,0-1.683Z" transform="translate(8.338 16.677) rotate(180)" fill="#041156"/></svg>
  );
};
